import { GridColumnProps } from "@roc/ui";
import { noOpComparator } from '@roc/ui/utils';

const idCellStyle = { left: 0, lineHeight: '35px', overflow: 'visible' };
const wrappedCellStyle = { lineHeight: '18px' };
const centeredCellStyle = { display: 'flex', alignItems: 'center', justifyContent: 'center' };

const formatDate = (params) => {
  if (!params?.value) return '';
  const value = params.value;
  if (Array.isArray(value) && value.length >= 3) {
    return `${String(value[1]).padStart(2, '0')}/${String(value[2]).padStart(2, '0')}/${value[0]}`;
  }
  if (typeof value === 'string') {
    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) {
      return date.toLocaleDateString();
    }
  }
  return value;
};

export const CLOSING_COORDINATOR_COLUMNS: GridColumnProps[] = [
  {
    field: 'loanId',
    headerName: 'Loan ID',
    cellRenderer: 'loanIdCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellClass: 'badge-overflow-cell',
    cellStyle: idCellStyle,
    minWidth: 100,
  },
  {
    field: 'expectedClosingDate',
    headerName: 'Expected Closing Date',
    valueFormatter: formatDate,
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    minWidth: 120,
  },
  {
    field: 'loanStatus',
    headerName: 'Loan Status',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: wrappedCellStyle,
    minWidth: 90,
  },
  {
    field: 'agreedDate',
    headerName: 'Agreed Date',
    valueFormatter: formatDate,
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    minWidth: 100,
  },
  {
    field: 'propertyAddress',
    headerName: 'Property Address',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: wrappedCellStyle,
    minWidth: 160,
  },
  {
    field: 'loanSubtype',
    headerName: 'Loan Sub-Type',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: wrappedCellStyle,
    minWidth: 90,
  },
  {
    field: 'attorney',
    headerName: 'Closing Attorney',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: wrappedCellStyle,
    minWidth: 110,
  },
  {
    field: 'closingCoordinator',
    headerName: 'Closing Coordinator',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: wrappedCellStyle,
    minWidth: 130,
  },
  {
    field: 'primaryCsc',
    headerName: 'Primary CSC',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: wrappedCellStyle,
    minWidth: 110,
  },
  {
    field: 'entityDocuments',
    headerName: 'Entity Document Status',
    cellRenderer: 'taskStatusCellRenderer',
    comparator: noOpComparator,
    headerClass: 'ag-header-wrap',
    cellStyle: centeredCellStyle,
    minWidth: 120,
  },
];
